var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngryLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "49EC24A2-A20A-441B-8AA2-6A471A10C147") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-Home-feed_storyline_charge-in-progress_v3",
    transform: "translate(-73.000000, -675.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-negative-emotion",
    transform: "translate(0.000000, 432.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "angry",
    transform: "translate(38.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 11.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C13.4314575,0 0,13.4314575 0,30 C0,46.5685425 13.4314575,60 30,60 C46.5685425,60 60,46.5685425 60,30 C59.981263,13.4392249 46.5607751,0.0187370435 30,0 Z",
    fill: "#EA8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.21,13.106 C16.4469359,12.6311029 16.8629109,12.2698516 17.3663229,12.1017976 C17.8697349,11.9337435 18.4193007,11.9726682 18.894,12.21 L26.894,16.21 C27.8825897,16.7037426 28.2837425,17.9054103 27.7899999,18.894 C27.2962574,19.8825896 26.0945897,20.2837425 25.106,19.79 L17.106,15.79 C16.6311029,15.5530641 16.2698516,15.1370891 16.1017976,14.6336771 C15.9337435,14.1302651 15.9726682,13.5806993 16.21,13.106 L16.21,13.106 Z",
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,24 C26,26.209139 24.209139,28 22,28 C19.790861,28 18,26.209139 18,24 C18,21.790861 19.790861,20 22,20 C24.209139,20 26,21.790861 26,24 Z",
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.082,45.324 C41.7309613,45.7220007 41.2361331,45.9641671 40.70647,45.9971773 C40.1768068,46.0301874 39.6557394,45.8513347 39.258,45.5 C33.9671737,40.835837 26.0328263,40.835837 20.742,45.5 C19.9135729,46.231225 18.649225,46.1524271 17.918,45.324 C17.186775,44.4955729 17.2655729,43.231225 18.094,42.5 C24.8973983,36.49986 35.1026017,36.49986 41.906,42.5 C42.3040007,42.8510387 42.5461671,43.3458669 42.5791773,43.87553 C42.6121874,44.4051932 42.4333347,44.9262606 42.082,45.324 L42.082,45.324 Z",
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,24 C34,21.790861 35.790861,20 38,20 C40.209139,20 42,21.790861 42,24 C42,26.209139 40.209139,28 38,28 C35.790861,28 34,26.209139 34,24 Z",
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.894,15.8 L34.894,19.8 C33.9054103,20.2937425 32.7037426,19.8925897 32.21,18.904 C31.7162575,17.9154103 32.1174103,16.7137426 33.106,16.22 L41.106,12.22 C42.0945897,11.7262574 43.2962574,12.1274103 43.79,13.116 C44.2837426,14.1045897 43.8825897,15.3062574 42.894,15.8 Z",
    fill: "#FFE7E7"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryLarge);
export default __webpack_public_path__ + "static/media/angry-large.a5a3f8a92a1882abc0343f919d1c9b4f.svg";
export { ForwardRef as ReactComponent };